common.View.create('galaxy::habitats.website.partials.ContentItem', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        //this.initShowThemes(); // Currently not needed; may be added later?
    },

    initShowThemes()
    {
        let i, container, width;

        // Get container and container width
        container = this.element.find('.someContainer')[0];
        width = container.offsetWidth;

        // Loop container items
        for (i = 0; i < container.children.length; i++)
        {
            // Get the 'right position' of the element
            let right = container.children[i].offsetLeft + container.children[i].offsetWidth;

            // Check if element is visible within container
            if( right > width ) {
                $(container.children[i]).hide();
            }
        }
    }

});